import { FC, useEffect, useLayoutEffect, useRef, useState } from "react";

import "./fenerbahce.css";

const CARD_SETTLE_MS = 600;
const ROOT_ATTR = "data-sso-fb";

const FenerbahceTheme: FC = () => {
  const [stageHeight, setStageHeight] = useState<number | null>(null);
  const stageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = stageRef.current?.parentElement;
    if (!root || typeof ResizeObserver === "undefined") return;

    let timer: number | null = null;
    let lastCardLeave = 0;
    const isCardHovered = () => !!root.querySelector(".sso-rd__portal-card:hover");
    const measure = () => {
      timer = null;
      if (!isCardHovered()) setStageHeight(root.offsetHeight);
    };

    const onMouseOut = (event: MouseEvent) => {
      const target = event.target as Element | null;
      if (target?.closest?.(".sso-rd__portal-card")) lastCardLeave = performance.now();
    };
    root.addEventListener("mouseout", onMouseOut);

    const observer = new ResizeObserver(() => {
      if (timer !== null) window.clearTimeout(timer);
      if (isCardHovered()) return;
      if (performance.now() - lastCardLeave < CARD_SETTLE_MS) {
        timer = window.setTimeout(measure, CARD_SETTLE_MS);
        return;
      }
      measure();
    });
    observer.observe(root);

    const listObserver = new MutationObserver(() => {
      if (timer !== null) window.clearTimeout(timer);
      timer = null;
      setStageHeight(root.offsetHeight);
    });
    listObserver.observe(root, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      listObserver.disconnect();
      root.removeEventListener("mouseout", onMouseOut);
      if (timer !== null) window.clearTimeout(timer);
    };
  }, []);

  useLayoutEffect(() => {
    document.documentElement.setAttribute(ROOT_ATTR, "");
    return () => document.documentElement.removeAttribute(ROOT_ATTR);
  }, []);

  return (
    <div
      ref={stageRef}
      className="sso-rd-fb__stage"
      style={stageHeight !== null ? { height: stageHeight } : undefined}
      aria-hidden="true"
    />
  );
};

export default FenerbahceTheme;
